import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class DevModeGuard {
  constructor(private router: Router) {}

  async canActivateChild(
    _childRoute: ActivatedRouteSnapshot
  ): Promise<boolean | UrlTree> {
    if (environment.dev) {
      return true;
    } else {
      return this.router.createUrlTree(['/']);
    }
  }
}
